var EECTACountDown = function() {

  var countdownTime,
    daysWrap,
    hoursWrap,
    minsWrap,
    secsWrap;

  var _init = function() {

    if (typeof wp_vars != 'undefined') {
      countdownTime = wp_vars.cta_countdown_time;
      
      daysWrap        = document.getElementById('ctaCountdownDays');
      hoursWrap       = document.getElementById('ctaCountdownHours');
      minsWrap        = document.getElementById('ctaCountdownMinutes');
      secsWrap        = document.getElementById('ctaCountdownSeconds');
      
      if (_hasDatePast(countdownTime * 1000)) {
        _displayEnd();
      } else {
        setInterval(_updateTimer, 1000);
      }
    }

  };

  var _updateTimer = function() {
    var dateEvent   = new Date(countdownTime * 1000);

    if (_hasDatePast(countdownTime * 1000)) {
      _displayEnd();
      return;
    }

    var dateCurrent = new Date();
    var dateDiff    = dateEvent - dateCurrent;
    var days        = Math.floor( dateDiff / (1000*60*60*24) );
    var hours       = Math.floor( dateDiff / (1000*60*60) );
    var mins        = Math.floor( dateDiff / (1000*60) );
    var secs        = Math.floor( dateDiff / 1000 );

    var d = days;
    var h = hours - days  * 24;
    var m = mins  - hours * 60;
    var s = secs  - mins  * 60;

    daysWrap.innerText  = d;
    hoursWrap.innerText = h;
    minsWrap.innerText  = m;
    secsWrap.innerText  = s;
  };

  var _hasDatePast = function(selectedDate) {
    if (selectedDate > Date.now()) {
      return false;
    }

    return true;
  };

  var _displayEnd = function() {
    daysWrap.innerText  = 0;
    hoursWrap.innerText = 0;
    minsWrap.innerText  = 0;
    secsWrap.innerText  = 0;
  };

  return {
    init: _init
  }

}();

if (document.getElementById('ctaCountdown')) {
  EECTACountDown.init();
}



// WEBPACK FOOTER //
// ./resources/assets/js/partials/CTACountDown.js